export function createTheme() {
  if (window.tailwind) {
    window.tailwind.config = {
      theme: {
        extend: {
          colors: {
            primary: '#3B82F6',  // 蓝色
            secondary: '#1E40AF', // 深蓝色
            dark: '#0F172A',     // 深色背景
          },
          fontFamily: {
            sans: ['Inter', 'sans-serif'],
          },
        }
      }
    };
  }
} 